export class Step2 {
    constructor() {}

    getmotclef = 'form.dive_re.getmotclef_liste_avi_';
    getcp = 'form.dive_re.getcp';
    getville = 'form.dive_re.getville';
    getnum = 'form.dive_re.getnum';
    gettypevoie = 'form.dive_re.gettypevoie';
    getnomvoie = 'form.dive_re.getnomvoie';
    getobjet = 'form.dive_re.getobjet';
    gettravaux = 'form.dive_re.gettravaux';
    getexecution = 'form.dive_re.getexecution';
    getfournitures = 'form.dive_re.getfournitures';
    getservices = 'form.dive_re.getservices';
    getspan4 = 'form.dive_re.getspan4';
    getlieuexecutionlivraison = 'form.dive_re.getlieuexecutionlivraison';
    getspan2 = 'form.dive_re.getspan2';
    getspan21 = 'form.dive_re.getspan21';
    getspan22 = 'form.dive_re.getspan22';
    getspan23 = 'form.dive_re.getspan23';
    ajouter = 'form.dive_re.ajouter';
    supprimer = 'form.dive_re.supprimer';
    getclassprincipale = 'form.dive_re.getclassprincipale';
    getclasssupplementaire = 'form.dive_re.getclasssupplementaire';
    getprocedure = 'form.dive_re.getprocedure';
    getspan5 = 'form.dive_re.getspan5';
}
